import React from 'react';
import LoginApi from '../services/login.service.js';
import { withRouter } from 'react-router-dom';
import '../stylesheets/bootstrap.min.css';
import './login.css';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  FormGroup,
  Label
} from 'reactstrap';
import GlobalLoader from '../common/global-loader/global-loader.jsx';
import logger from '../logger/logHelper';
import ZenTradeLogo from 'media/ZenTradesWhite.svg';
import LoginBackground from 'media/bg_login.png';
import { withTranslation } from 'react-i18next';
const apiservices = new LoginApi();

function updateSessionData(data) {
  const keys = Object.keys(data);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (key) {
      if (key === 'user') {
        const { user } = data;
        const { company } = user;
        const companyId = company.id;
        user.companyId = companyId;
        const userId = user.id;
        delete user.company;
        localStorage.setItem('current-user', JSON.stringify(user));
        localStorage.setItem('company', JSON.stringify(company));
        localStorage.setItem('company-id', companyId);
        localStorage.setItem('user-id', userId);
      } else if (typeof data[key] === 'object') {
        localStorage.setItem(key, JSON.stringify(data[key]));
      } else {
        localStorage.setItem(key, data[key]);
      }
    }
  }
}

function redirectToHome() {
  window.location.href = '/';
}

class Login extends React.Component {
  constructor(props) {
    super(props);
    document.getElementsByTagName(
      'body'
    )[0].style.backgroundImage = `url(${LoginBackground})`;
    if (props && props.history && props.history.listen && props.resetHeader) {
      props.resetHeader();
    }
    this.hideAlertMessageHandler = this.hideAlertMessageHandler.bind(this);
    this.state = {
      email: '',
      password: '',
      loginErrorOccured: false,
      loginErrorMsg: '',
      processingLogin: false,
      usernameInvalid: false,
      forgotPwMsg: '',
      showForgotDialog: false,
      mailSent: false,
      rememberMe: true,
      t: props.t
    };
  }

  onChange = (id, event) => {
    this.setState({
      [id]: event.target.value
    });
  };

  sendEmail = () => {
    const self = this;
    this.setState(
      {
        showForgotDialog: !this.state.showForgotDialog,
        processingLogin: true,
        loaderText: this.state.t('login.sending_password_reset_email')
      },
      () => {
        apiservices
          .forgotPassword(this.state.email)
          .then(function (res) {
            self.setState(
              {
                mailSent: true,
                processingLogin: false
              },
              () => self.hideAlertMessageHandler()
            );
          })
          .catch((error) => {
            const message = error.description || error.message || error;
            self.setState(
              {
                loginErrorOccured: true,
                loginErrorMsg: message,
                processingLogin: false
              },
              () => self.hideAlertMessageHandler()
            );
            logger.logError(error);
          });
      }
    );
  };

  showForgotDialog = () => {
    // Show dialog
    const emailRegexp = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i;
    if (!this.state.email) {
      this.setState(
        {
          forgotPwMsg: this.state.t('login.enter_username'),
          usernameInvalid: true,
          showForgotDialog: false
        },
        () => this.hideAlertMessageHandler()
      );
    } else if (!emailRegexp.test(this.state.email)) {
      this.setState(
        {
          forgotPwMsg: this.state.t('login.invalid_email'),
          usernameInvalid: true,
          showForgotDialog: false
        },
        () => this.hideAlertMessageHandler()
      );
    } else {
      this.setState(
        {
          forgotPwMsg: null,
          usernameInvalid: false,
          showForgotDialog: true
        },
        () => this.hideAlertMessageHandler()
      );
    }
  };

  componentDidMount() {
    if (apiservices.getLoginState()) {
      redirectToHome();
    }
  }

  rememberMe = (event) => {
    const { checked } = event.target;
    this.setState({ rememberMe: checked });
  };

  onSaveClick = () => {
    const { email, password, rememberMe, t } = this.state;
    if (!email || !password) {
      this.setState(
        {
          loginErrorOccured: true,
          loginErrorMsg: !email
            ? t('login.enter_email')
            : t('login.enter_password'),
          processingLogin: false
        },
        () => this.hideAlertMessageHandler()
      );
      return;
    }
    const self = this;
    this.setState(
      {
        processingLogin: true
      },
      () => {
        apiservices.login(email, password, rememberMe).then(
          (successResp) => {
            updateSessionData(successResp);

            if (apiservices.getLoginState()) {
              redirectToHome();
            } else {
              window.location.reload(true);
            }
            self.setState({
              processingLogin: false
            });
          },
          (err) => {
            const message = err.description || t('login.login_error');
            self.setState(
              {
                loginErrorOccured: true,
                loginErrorMsg: message,
                processingLogin: false
              },
              () => self.hideAlertMessageHandler()
            );
            logger.logError(
              `login error for username:${email} \n${JSON.stringify(err)}`
            );
          }
        );
      }
    );
  };

  hideAlertMessageHandler() {
    window.setTimeout(() => {
      this.setState({
        loginErrorOccured: false,
        usernameInvalid: false,
        mailSent: false
      });
    }, 10000);
  }

  toggleDialog = () => {
    this.setState({
      showForgotDialog: !this.state.showForgotDialog
    });
  };

  render() {
    const { email, password, loaderText, rememberMe, t } = this.state;

    return (
      <div className='loginPage'>
        {this.state.processingLogin ? (
          <GlobalLoader message={loaderText || t('login.loader')} />
        ) : null}

        <Alert color='success' fade isOpen={this.state.mailSent}>
          {t('login.email_sent')}
        </Alert>

        <Modal
          isOpen={this.state.showForgotDialog}
          toggle={this.toggleDialog}
          className={this.props.className}
        >
          <ModalHeader>{t('login.forgot_password')}</ModalHeader>
          <ModalBody>
            {t('login.reset_password_link_text')}: <b>{this.state.email}</b>
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' onClick={this.toggleDialog}>
              {t('button.cancel')}
            </Button>{' '}
            <Button color='primary' onClick={this.sendEmail}>
              {t('button.ok')}
            </Button>
          </ModalFooter>
        </Modal>

        <div className='login-form'>
          <header className='loginHeader'>
            <img
              src={ZenTradeLogo}
              alt='Logo'
              title='Logo'
              className='logo_login'
            />
          </header>
          <div>
            <div style={{ fontSize: '0.8em', marginTop: '10px' }}>
              <Alert isOpen={this.state.usernameInvalid} color='light'>
                {this.state.forgotPwMsg}
              </Alert>
            </div>

            <input
              type='email'
              placeholder={t('login.enter_email_placeholder')}
              className='usernameInput'
              value={email}
              id='email'
              onChange={this.onChange.bind(this, 'email')}
            />
            <input
              type='password'
              placeholder={t('login.password_placeholder')}
              className='passwordInput'
              value={password}
              id='password'
              onChange={this.onChange.bind(this, 'password')}
            />

            <div style={{ fontSize: '0.8em', marginTop: '10px' }}>
              <Alert isOpen={this.state.loginErrorOccured} color='danger'>
                {this.state.loginErrorMsg}
              </Alert>
            </div>
            <FormGroup check style={{ color: 'white', marginBottom: '10px' }}>
              <Label check>
                <Input
                  type='checkbox'
                  checked={rememberMe}
                  onChange={this.rememberMe.bind(this)}
                />{' '}
                {t('login.remember_me')}
              </Label>
            </FormGroup>

            <button onClick={this.onSaveClick}>{t('button.sign_in')}</button>
          </div>
          <br />
          <div>
            <span
              style={{
                color: 'white',
                marginTop: '10px',
                fontSize: '0.85em',
                cursor: 'pointer'
              }}
              onClick={this.showForgotDialog.bind(this)}
            >
              {t('login.forgot_password?')}
            </span>
          </div>
          <div className='footer' id='footer'>
            <div>
              <a
                href='https://zentrades.pro/terms-of-use/'
                style={{ color: 'white' }}
              >
                {t('login.terms_of_use')}
              </a>
            </div>
            <div>
              <a
                href='https://zentrades.pro/privacy-policy/'
                style={{ color: 'white' }}
              >
                {t('login.privacy_policy')}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withRouter(Login));
